var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerceDanneggiata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8743 53.1668H15.7077M27.791 33.8335V53.1668M27.791 33.8335C35.7986 33.8335 42.291 27.1877 42.291 19.3335C42.291 11.4793 37.4577 4.8335 37.4577 4.8335H18.1243C18.1243 4.8335 13.291 11.4793 13.291 19.3335C13.291 27.3411 19.7834 33.8335 27.791 33.8335Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7917 4.8335L25.375 12.0835L30.2083 13.2918L27.7917 20.5418M18.125 4.8335H37.4583",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerceDanneggiata);
export default __webpack_public_path__ + "static/media/MerceDanneggiata.cc7fcf32d704b34d8c24740864e88a32.svg";
export { ForwardRef as ReactComponent };